function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M256 161.678l128 94.316-128 94.316-128-94.316z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 53.894,
  fill: "#f0f0f0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M229.052 252.626a90.66 90.66 0 00-26.93 4.07c.377 29.44 24.348 53.193 53.877 53.193 18.259 0 34.386-9.089 44.134-22.981-16.676-20.879-42.341-34.282-71.081-34.282zm79.843 13.694c.649-3.344 1-6.793 1-10.326 0-29.765-24.13-53.895-53.895-53.895-22.21 0-41.275 13.438-49.527 32.623a111.276 111.276 0 0122.579-2.307c31.304.001 59.622 13.012 79.843 33.905z",
  fill: "#0052b4"
});

const SvgBrazil = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrazil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/brazil.2d778bfe.svg";
export { ForwardRef as ReactComponent };